import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import moment from "moment";
import { BaseHttpService } from "./../base/base-http.service";
import { Observable, from, throwError } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  private readonly USER_INFO = "USER_INFO";
  public expiresAt;

  constructor(private storage: Storage, private baseHttp: BaseHttpService,private http: HttpClient) {
    this.initStorage();
  }

  private async initStorage() {
    await this.storage.create();
  }

  // setAuthSession(authResult, isMonthExpiry) {
  //   if (isMonthExpiry) {
  //     this.expiresAt = moment().add(1, 'month');
  //   } else {
  //     this.expiresAt = moment().add(1, 'day');
  //   }
  //   this.setStorageData(authResult);
  // }

  setStorageData(authResult) {
    this.storage.set(this.USER_INFO, {
      TOKEN: authResult.TOKEN,
      EMAIL: authResult.EMAIL,
      USER_NAME: authResult.USER_NAME,
      USER_ROLE: authResult.USER_ROLE,
      EXPIRY: JSON.stringify(this.expiresAt.valueOf()),
    });
  }

  // ---------------------------------
  // Called when login or refresh API succeeds
  // ---------------------------------
  setAuthSession(authResult, isMonthExpiry, updatedAuthData) {
    const accessToken = authResult.accessToken || authResult.TOKEN;
    const refreshToken =
      updatedAuthData.refreshToken || updatedAuthData.REFRESH_TOKEN;

    // Decode expiry from token
    const decoded: any = this.decodeJWT(accessToken);
    const exp = decoded?.exp
      ? decoded.exp * 1000
      : moment().add(1, "day").valueOf();

    this.expiresAt = exp;

    this.storage.set(this.USER_INFO, {
      TOKEN: accessToken,
      REFRESH_TOKEN: refreshToken,
      EMAIL: authResult.EMAIL,
      USER_NAME: authResult.USER_NAME,
      USER_ROLE: authResult.USER_ROLE,
      EXPIRY: exp,
    });

    this.setJWTToken(accessToken);
  }

  clearSession() {
    this.storage.clear();
  }

  // getUserInfo() {
  //   return new Promise((resolve) => {
  //     this.storage.get(this.USER_INFO).then((userData: object) => {
  //       if (userData !== undefined) {
  //         resolve(userData);
  //       } else {
  //         resolve(false);
  //       }
  //     }, (error) => {
  //       resolve(false);
  //     });
  //   }).catch(() => {
  //     throw new Error('Promise failure');
  //   });
  // }

  async getUserInfo(): Promise<object | false> {
    try {
      const userData = await this.storage.get(this.USER_INFO);
      return userData !== undefined ? userData : false;
    } catch (error) {
      return false;
    }
  }

  getUserEmail() {
    return new Promise((resolve) => {
      this.storage
        .get(this.USER_INFO)
        .then(
          (userData: any) => {
            if (userData && userData.EMAIL) {
              resolve(userData.EMAIL);
            } else {
              resolve(false);
            }
          },
          (error) => {
            resolve(false);
          }
        )
        .catch(() => {
          resolve(false);
        });
    }).catch(() => {
      throw new Error("Promise failure");
    });
  }

  //OLD
  // isLoggedIn(): Promise<any> {
  //   return new Promise((resolve) => {
  //     this.getUserInfo().then(
  //       (userData) => {
  //         if (userData) {
  //           const expiryTS = userData["EXPIRY"];
  //           const currentTS = JSON.stringify(moment().valueOf());
  //           if (expiryTS > currentTS) {
  //             resolve(true);
  //           } else {
  //             resolve(false);
  //           }
  //         } else {
  //           resolve(false);
  //         }
  //       },
  //       (error) => {
  //         resolve(false);
  //       }
  //     );
  //   }).catch(() => {
  //     throw new Error("Promise failure");
  //   });
  // }

  isLoggedIn(): Promise<any> {
    return new Promise((resolve) => {
      this.getUserInfo().then(
        (userData) => {
          resolve(!!userData); //  only check if user info exists
        },
        () => resolve(false)
      );
    });
  }

  isVendorLogin() {
    return new Promise((resolve) => {
      this.getUserInfo().then(
        (userData) => {
          if (userData && userData["USER_ROLE"] === "ROLE_TRANSPORTER") {
            resolve(true);
          } else {
            resolve(false);
          }
        },
        (error) => {
          resolve(false);
        }
      );
    }).catch(() => {
      throw new Error("Promise failure");
    });
  }

  fetchProfile(email) {
    return new Promise(async (resolve) => {
      // let user = '';
      // await this.getUserInfo().then((userData) => {
      //   user = userData['EMAIL'];
      // });
      this.baseHttp
        .get("auth/rest/profile/getUserProfileForApp?user=" + email)
        .subscribe(
          async (response) => {
            if (response) {
              resolve(response);
            } else {
              resolve(false);
            }
          },
          (error) => {
            resolve(false);
          }
        );
    }).catch(() => {
      throw new Error("Promise failure");
    });
  }

  getStorageData(key) {
    return new Promise((resolve) => {
      this.storage.get(key).then(
        (data: object) => {
          if (data !== undefined) {
            resolve(data);
          } else {
            resolve(false);
          }
        },
        (error) => {
          resolve(false);
        }
      );
    }).catch(() => {
      throw new Error("Promise failure");
    });
  }

  updateUserEmail(email) {
    return new Promise(async (resolve) => {
      this.getUserInfo().then(
        async (data) => {
          const userData = data;
          userData["EMAIL"] = email;
          await this.storage.set(this.USER_INFO, userData);
          resolve(true);
        },
        (error) => {
          resolve(false);
        }
      );
    }).catch(() => {
      throw new Error("Promise failure");
    });
  }

  setJWTToken(token) {
    this.storage.set("JWTToken", token);
  }

  setOldAccessToken(Oldtoken) {
    this.storage.set("oldAccessToken", Oldtoken);
  }
  googleLogin(body) {
    return this.baseHttp.post("auth/rest/loginApp/googleLogin", body);
  }

  public refreshToken(): Observable<string> {
    return from(this.storage.get(this.USER_INFO)).pipe(
      switchMap((user: any) => {
        const refreshToken: string | undefined = user?.REFRESH_TOKEN;
        const oldAccessToken: string | undefined = user?.TOKEN;

        if (!refreshToken || !oldAccessToken) {
          return throwError(() => new Error("[AuthService] Missing tokens"));
        }
      
        const body = new Blob([refreshToken], { type: "application/json" });

        return this.baseHttp.post("auth/rest/login/validateToken", body).pipe(
          switchMap((resp: any) => {
            console.log("4. validateToken API called ", resp);

            const newAccessToken: string =
              typeof resp === "string"
                ? resp
                : resp?.accessToken ?? resp?.TOKEN ?? resp?.token;

            // RefreshToken is always coming back null → keep the old one
            const newRefreshToken: string = user?.REFRESH_TOKEN;

            if (!newAccessToken) {
              return throwError(
                () => new Error("[AuthService] No new access token returned")
              );
            }

            const decoded: any = this.decodeJWT(newAccessToken);
            const exp = decoded?.exp
              ? decoded.exp * 1000
              : Date.now() + 86400000;

            const updatedUser = {
              ...(user || {}),
              TOKEN: newAccessToken,
              REFRESH_TOKEN: newRefreshToken, // never overwrite with null
              EXPIRY: exp,
            };
      
            return from(
              Promise.all([
                this.storage.set(this.USER_INFO, updatedUser),
                this.storage.set("JWTToken", newAccessToken),
              ])
            ).pipe(map(() => newAccessToken));
          }),
          catchError((err) => {
            console.error("[AuthService] Refresh failed", err);
            return throwError(() => err);
          })
        );
      })
    );
  }

  private decodeJWT(token: string): any {
    try {
      const payload = token.split(".")[1];
      return JSON.parse(atob(payload));
    } catch (e) {
      console.error("[AuthService] Failed to decode JWT:", e);
      return null;
    }
  }

  logout(logoutUrl,headers) {    
    return this.http.post(logoutUrl, {}, { headers });
  }

}
